import React, { useContext, useRef } from 'react';
import { LoginLink } from '../../modules/auth/components/login';
import { RegistrationLink } from '../../modules/auth/components/registration';
import { ResetLink } from '../../modules/auth/components/reset';
import { connect } from 'react-redux';
import { HomeOutlined, MenuOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { ConnectedCart } from '../Cart';
import { NavbarItemMobile } from './NavbarItemMobile';
import { ConnectedProfile } from '../Profile';
import { ConnectedMenuNavMobile } from '../MenuNavMobile';
import { useHeightWatcher } from '../../hooks/useHeightWatcher';
import { openLeftMenu } from '../../actions/openMenu';
import { Context } from 'app/index';
import { MenuTypes } from 'app/components/navbar/Navbar';

export const NavbarMobile = ({ className, setting }) => {
    const ref = useRef(null);
    const {
        settings: {
            navbar: { settings: navbarSettings },
        },
    } = useContext(Context);
    const isCompact = navbarSettings.type === MenuTypes.compact;
    useHeightWatcher(ref, 'mobileNav');
    return (
        <div ref={ref} className={classNames(className, 'navbar_mobile')}>
            <nav
                className="navbar__nav"
                style={{
                    color: setting.content.navbar.color,
                    background: setting.content.navbar.background,
                }}
            >
                <NavbarItemMobile
                    name={setting.content.primary.name}
                    icon={<HomeOutlined />}
                    to={'/'}
                />
                {isCompact ? null : <NavbarMenuItem />}
                <ConnectedMenuNavMobile />
                <ConnectedProfile mobile />
                <ConnectedCart mobile />
            </nav>
        </div>
    );
};

const NavbarMenuItem = connect(null, (dispatch) => ({
    toggleOpenLeftMenu: () => {
        dispatch(openLeftMenu());
    },
}))(({ toggleOpenLeftMenu }) => {
    return (
        <NavbarItemMobile
            onClick={toggleOpenLeftMenu}
            name={'Меню'}
            icon={<MenuOutlined />}
        />
    );
});

const mapStateToProps = (state) => {
    return {
        setting: state.appState.setting,
    };
};

const dispatchToProps = (dispatch) => {
    return {
        openLogin: () => {
            dispatch({
                type: 'openMiniModal',
                header: 'Вход',
                children: <LoginLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        openRegistration: () => {
            dispatch({
                type: 'openMiniModal',
                header: 'Регистрация',
                children: <RegistrationLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        openReset: () => {
            dispatch({
                type: 'openMiniModal',
                header: 'Восстановление пароля',
                children: <ResetLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
    };
};

export const NavbarMobileLink = connect(
    mapStateToProps,
    dispatchToProps
)(NavbarMobile);
